import { gql } from '../__generated__';

const ModelItem = gql(`
  fragment SubscriptionModelItem on SubscriptionModel {
    id
    bksId
    name
    number
    parentId
    upgradesTo
    salesText
    isRecommended
    product
    isSellable
    price {
      singleUser
      extraUser
    }
    pendingPriceChange {
      id
      timeOfChange
      newPrice {
        singleUser
        extraUser
      }
    }
    content {
      kind
      series
      docIds
      includesOldVersions
    }
    appIds
  }
`);

export let GET_SUBSCRIPTIONS = gql(`
  query GetSubscriptions {
    subscriptions: getSubscriptions {
      ...SubscriptionModelItem
    }
  }
`);

export const UPDATE_PRICE = gql(`
  mutation ChangeSubscriptionPrice($input: ChangeSubscriptionPriceInput!) {
    changeSubscriptionPrice(input: $input) {
      ...SubscriptionModelItem
    }
  }
`);

export const CANCEL_PRICE_UPDATE = gql(`
  mutation CancelSubscriptionPriceChange($input: CancelSubscriptionPriceChangeInput!) {
    cancelSubscriptionPriceChange(input: $input) {
      ...SubscriptionModelItem
    }
  }
`);

export const GET_SUBSCRIPTION_USAGE = gql(`
  query GetSubscriptionUsage {
    usage: getSubscriptionUsage {
      subscriptionId
      licenses
      users
    }
  }
`);

export const GET_MACONOMY_ITEM = gql(`
  query GetMaconomyItem($number: String) {
    item: getMaconomyItem(number: $number) {
      number
      title
      product
      blocked
    }
  }
`);

export const GET_SUBSCRIPTION_DELETION = gql(`
  query GetSubscriptionDeletion($subscriptionId: Int!) {
    deletion: getSubscriptionDeletion(subscriptionId: $subscriptionId) {
      canDelete
      blockers
    }
  }
`);

export const DELETE_SUBSCRIPTION = gql(`
  mutation DeleteSubscription($input: DeleteSubscriptionInput!) {
    deleteSubscription(input: $input)
  }
`);

export const CREATE_SUBSCRIPTION = gql(`
  mutation CreateSubscription($input: CreateSubscriptionInput!) {
    createSubscription(input: $input) {
      ...SubscriptionModelItem
    }
  }
`);

export const UPDATE_SUBSCRIPTION = gql(`
  mutation UpdateSubscription($input: UpdateSubscriptionInput!) {
    updateSubscription(input: $input) {
      ...SubscriptionModelItem
    }
  }
`);

export const GET_SUBSCRIPTION_GUIDES = gql(`
  query GetSubscriptionGuides {
    guides: getSubscriptionGuides {
      docId
      number
      title
      isCurrent
      isWithdrawn
      product
      series
    }
  }
`);

export const GET_SUBSCRIPTION_APPS = gql(`
  query GetSubscriptionApps {
    apps: getSubscriptionApps {
      appId
      name
      category
    }
  }
`);

export const CHANGE_SUBSCRIPTION_APPS = gql(`
  mutation ChangeSubscriptionApps($input: ChangeSubscriptionAppsInput!) {
    changeSubscriptionApps(input: $input) {
      ...SubscriptionModelItem
    }
  }
`);

export const CHANGE_SUBSCRIPTION_CONTENT = gql(`
  mutation ChangeSubscriptionContent($input: ChangeSubscriptionContentInput!) {
    changeSubscriptionContent(input: $input) {
      ...SubscriptionModelItem
    }
  }
`);

export const GET_PRODUCT_CHANGES = gql(`
  query GetProductChanges($kind: ProductKind, $subscriptionId: Int, $limit: Int) {
    changes: getProductChanges(kind: $kind, subscriptionId: $subscriptionId, limit: $limit) {
      id
      isExternal
      description
      createdAt
      createdByName
    }
  }
`);
